export const CHIP_CLASS_NAME = '__CHIP__';
